import { render, staticRenderFns } from "./user-management-cta.vue?vue&type=template&id=40fc43b6"
import script from "./user-management-cta.vue?vue&type=script&lang=js"
export * from "./user-management-cta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports